import { Column } from "primereact/column";
import { formatCurrency } from "../../../../../../utils/formatCurrency";
import { formatDate } from "../../../../../../utils/formatDate";
import { Checkbox } from "primereact/checkbox";
import { DataTable } from "primereact/datatable";
import { useParcelContext } from "./ParcelContext";
import { Skeleton } from "primereact/skeleton";

export const TableData = () => {
  const {
    parcels,
    itemsSelected,
    setItemsSelected,
    selectAll,
    setSelectAll,
    showCheckboxes,
  } = useParcelContext();

  //COLUNAS DA TABELA
  const columns = [
    { field: "id", header: `ID` },
    { field: "sequence_number", header: `N° Parcela` },
    {
      field: "description",
      header: `Descrição`,
      body: (rowData) => rowData.description.name,
    },
    {
      field: "value",
      header: "Valor Parcela",
      body: (rowData) => formatCurrency(rowData.value),
    },
    {
      field: "due_date",
      header: "Data Vencimento",
      body: (rowData) => formatDate(rowData.due_date),
    },
    {
      field: "status",
      header: "Situação",
      body: (rowData) => {
        return rowData.status === 0 ? "Em Aberto" : "Pago";
      },
    },
    {
      field: "payment_value",
      header: "Valor Recebido",
      body: (rowData) => formatCurrency(rowData.payment_value),
    },
    {
      field: "payment_date",
      header: "Data de Recebimento",
      body: (rowData) => formatDate(rowData.payment_date),
    },
    { field: "cod_link", header: "Vínculo" },
    {
      field: "date_billet",
      header: "Data Atualizada",
      body: (rowData) => formatDate(rowData.date_billet),
    },
    {
      field: "shipping",
      header: "Remessa",
      body: (rowData) => {
        return renderStatus(rowData.shipping);
      },
    },
  ];

  // Função para renderizar o valor com base no estado
  const renderStatus = (status) => {
    /*
        *shipping
            #0 Não solicitou remessa
            #1 Remessa solicitada
            #2 Remessa em progessamento
            #3 Remessa gerada
            #4 Remessa com erro
            #5 Estorno remessa solicitada
            #6 Estorno remessa  em progessamento
            #7 Estorno remessa com erro
    */

    switch (status) {
      case 0:
        return "Não";
      case 1:
        return "Em Preparação";
      case 2:
        return "Em Processo";
      case 3:
        return "Gerada";
      case 4:
        return "Erro";
      case 5:
        return "Estorno Solicitado";
      case 6:
        return "Estorno em Processo";
      case 7:
        return "Erro ao Estornar";
      default:
        return "";
    }
  };
  const handleSelectAll = () => {
    const newSelectAll = !selectAll;
    setSelectAll(newSelectAll);

    if (newSelectAll) {
      setItemsSelected(filteredRows);
    } else {
      setItemsSelected([]);
    }
  };


  const rowClassName = (rowData) => {
    var today = new Date();
    today.setHours(0, 0, 0, 0);

    var dueDate = new Date(rowData.due_date);
    dueDate.setDate(dueDate.getDate() + 1);
    dueDate.setHours(0, 0, 0, 0);

    if (
      ( rowData.shipping === 0|| rowData.shipping ===1 || rowData.shipping === 2 || rowData.shipping === 3 || rowData.shipping === 4 ) &&
      rowData.status === 0 &&
      ((rowData.date_billet && new Date(rowData.date_billet).setDate(new Date(rowData.date_billet).getDate() + 1) < today.getTime()) ||
        (!rowData.date_billet && dueDate < today))
    ) {
      return "bg-red-50";
    }

    if (rowData.shipping != 0 && rowData.status === 0) {
      return "bg-orange-50";
    }

    if (rowData.date_billet) {
      var billetDate = new Date(rowData.date_billet);
      billetDate.setDate(billetDate.getDate() + 1);
      billetDate.setHours(0, 0, 0, 0);


      if (rowData.status === 0 && billetDate < today) {
        return "bg-red-50";
      }
      return rowData.status === 1 ? "bg-teal-50" : "";
    } else {
      if (rowData.status === 0 && dueDate < today) {
        return "bg-red-50";
      }
    }

    return rowData.status === 1 ? "bg-teal-50" : "";
  };

  const isRowSelected = (rowData) => itemsSelected.some((row) => row.id === rowData.id);

  const handleRowSelect = (rowData) => {
    const isSelected = isRowSelected(rowData);
    let updatedSelectedRows = [...itemsSelected];

    if (isSelected) {
      updatedSelectedRows = updatedSelectedRows.filter((row) => row.id !== rowData.id);
    } else {
      updatedSelectedRows.push(rowData);
    }

    // Atualiza o estado do `selectAll` com base na seleção
    setSelectAll(updatedSelectedRows.length === filteredRows.length);
    setItemsSelected(updatedSelectedRows);
  };
  const filteredRows = [];
  return (
    <>
      {!parcels ? (
        <Skeleton variant="rect" width="100%" height={550} />
      ) : (
        <div className="px-0 py-3">
          <DataTable
            rows={30}
            paginator
            stripedRows
            sortMode="multiple"
            selectionMode="multiple"
            rowsPerPageOptions={[30, 100, 200]}
            value={parcels}
            rowClassName={rowClassName}
            totalRecords={parcels}
            emptyMessage="Nenhuma Informação foi encontrada."
            tableStyle={{ minWidth: "0.8rem", fontSize: "0.7rem" }}
          >
            <Column
              field="check_id"
              header={
                <Checkbox onChange={handleSelectAll} checked={selectAll} />
              }
              body={(rowData) => {
                const isShippingOne = rowData.shipping === 0;

                // Verifica se é a primeira do vínculo
                const isBondeMaster = rowData.main_link === 1;

                const isLinkEmpty = rowData.cod_link == null;
                const isStatusParcel = rowData.status === 0;

                // Lógica para renderizar checkboxes
                if (
                  showCheckboxes &&
                  ((isShippingOne && isLinkEmpty) ||
                    (isShippingOne && isBondeMaster)) &&
                  isStatusParcel
                ) {
                  const index = filteredRows.findIndex(
                    (row) => row.id === rowData.id
                  );
                  if (index === -1) {
                    filteredRows.push(rowData);
                  }
                  return (
                    <Checkbox
                      checked={itemsSelected.some(
                        (row) => row.id === rowData.id
                      )}
                      onChange={() => handleRowSelect(rowData)}
                    />
                  );
                } else if (
                  !showCheckboxes &&
                  ((rowData.shipping === 3 && isLinkEmpty) ||
                    (rowData.shipping === 3 && isBondeMaster)) &&
                  isStatusParcel
                ) {
                  const index = filteredRows.findIndex(
                    (row) => row.id === rowData.id
                  );
                  if (index === -1) {
                    filteredRows.push(rowData);
                  }
                  return (
                    <Checkbox
                      checked={itemsSelected.some(
                        (row) => row.id === rowData.id
                      )}
                      onChange={() => handleRowSelect(rowData)}
                    />
                  );
                } else {
                  return null;
                }
              }}
            />
            {columns.map((col) => (
              <Column
                key={col.field}
                field={col.field}
                header={col.header}
                body={col.body}
                selectionMode={col.selectionMode}
              />
            ))}
          </DataTable>
        </div>
      )}
    </>
  );
};
